import { Component } from 'solid-js';
import { twclsx } from '../shared';

type Props = {
  class?: string;
};

const ComingSoon: Component<Props> = props => (
  <div class={twclsx(props.class, 'pt-0')}>
    <div class={twclsx('flex', 'items-center', 'justify-center', 'min-h-screen', 'bg-gray-100', 'text-center')}>
      <div class={twclsx('bg-white', 'p-8', 'rounded-lg', 'shadow-lg', 'max-w-sm')}>
        <h2 class={twclsx('text-2xl', 'font-bold', 'mb-6')}>Coming Soon!</h2>
        <p class={twclsx('text-gray-700', 'mb-6')}>
          We're working hard to finish the development of this page, please checkout other pages.
        </p>
      </div>
    </div>
  </div>
);

export default ComingSoon;
